 
import moment from 'moment' 

function AgeFiter(value, expanded) {
    if (!value)
        return value;

    var years = moment().diff(value, 'years');

    if (years == 0 && expanded) {
        var months = moment().diff(value, 'months');
        if (months == 0)
            return "less than month";
        else if (months == 1)
            return '1 month';
        else
            return `${months} months`;
    }

    return years;
}

function AgeFiterFactory(): Function {
    return AgeFiter;
}

angular
    .module('app')
    .filter('age', [AgeFiterFactory]);